import React from 'react';
import { PageContainer } from '@amzn/atoz-web/PageContainer';
import { View } from '@amzn/atoz-web/View';
import { Row } from '@amzn/atoz-web/Row';
import { styledWithTheme } from '@amzn/atoz-web/Theme';
export var SwapPageLayout = function (_a) {
    var swapPageDaySelector = _a.swapPageDaySelector, swapPageDay = _a.swapPageDay, swapPageFooter = _a.swapPageFooter, swapPageBanner = _a.swapPageBanner;
    return (React.createElement(SwapPageContainer, { dataTestId: "SwapPageLayout", backgroundColor: "neutral0" },
        swapPageBanner,
        swapPageDaySelector,
        React.createElement(View, null, swapPageDay),
        React.createElement(Row, null, swapPageFooter)));
};
var SwapPageContainer = styledWithTheme(PageContainer)("\n    margin: 0;\n    padding: 0;\n");
